import $ from 'jquery';
import _ from 'underscore';
import { $window, jqGetElemByCmpName, jqGetElemById, isAndroid } from 'util/global';
import * as deferred from 'util/deferred';
import { onDOMReady } from 'util/onload';
import comments from 'app/comments';

var webview = {};

/**
 * Load all deferred components on a page 3 at a time, insert into DOM 5 at a time
 * @param {Array} vkeys
 */
webview.loadDeferredComponents = function (vkeys) {

    onDOMReady(() => {
        $window.off('scroll.deferred');

        var numCurrentlyLoading = 0,
            components = $('.cmp-deferred').toArray();

        var loadComponents = (function () {
            var maxCurrentlyLoading = 3;
            return function () {
                if (!components.length) {
                    return;
                }
                while (numCurrentlyLoading < maxCurrentlyLoading) {
                    numCurrentlyLoading++;

                    if (components[0]) {
                        deferred.load($(components.shift()));
                    } else {
                        components.shift();
                    }
                }
            };
        })();

        var queueComponentHandler = (function () {
            var componentHandlers = [],
                maxComponentsBeforeDequeue = 5,
                totalComponents = components.length,
                handledComponents = 0;

            return function (handler) {
                componentHandlers.push(handler);
                if (componentHandlers.length >= maxComponentsBeforeDequeue
                        || (handledComponents + componentHandlers.length) >= totalComponents) {
                    componentHandlers.forEach(function (handler, i) {
                        _.defer(function () {
                            comments.init(handler());
                        });
                        handledComponents ++;
                    });
                    componentHandlers = [];
                }
            };
        })();

        var vkeyHandler = function (action, action_key) {
            numCurrentlyLoading --;
            loadComponents();
            queueComponentHandler(function () {
                return window.vkey.handle(action, action_key);
            });
        };

        vkeys.forEach(function (key) {
            window.vkey[key] = vkeyHandler;
        });

        loadComponents();
    });
}

webview.solutionDiscussions = function ($container) {
    comments.init();
    comments.add_form();

    if (!isAndroid) {
        // load all deferred components (iOS only)
        webview.loadDeferredComponents(['solutiondiscussions_publicsolvablesolutioncomments']);
    }
};

webview.disputeDiscussions = function ($container) {
    comments.init();
    comments.add_form();

    if (!isAndroid) {
        // load all deferred components (iOS only)
        webview.loadDeferredComponents(['disputediscussions_publicsolvabledisputelist']);
    }
};


/** Controller */
webview.editProblem = () => {
    setTimeout(() => {
        const $component = jqGetElemByCmpName('assessment_webview_edit_problem');

        // switch to edit view and fade in
        jqGetElemById('question-text-edit').click();
        $component.addClass('in');

        window.vkey.assessment_webview_edit_problem = (action, actionKey) => {
            // if successfully edited and saved, let the client know
            if (action.new_html.indexOf('webview_solvable_saved') !== -1) {
                $component.hide();
                window.location = 'problem://saved';
            } else {
                window.vkey.handle(action, actionKey);
            }
        };
    }, 100);
};


module.exports = webview;
